import { useEffect, useState } from "react";
import { Download, Share, X, PlusSquare } from "lucide-react";

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export default function InstallBanner() {
  const [prompt, setPrompt] = useState(null);
  const [hidden, setHidden] = useState(() => isStandalone() || localStorage.getItem("installDismissed") === "1");
  const [showIos, setShowIos] = useState(false);

  useEffect(() => {
    const h = (e) => { e.preventDefault(); setPrompt(e); };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);

  if (hidden || window.innerWidth >= 1024 || (!prompt && !isIOS())) return null;
  const dismiss = () => { localStorage.setItem("installDismissed", "1"); setHidden(true); };
  const install = async () => {
    if (prompt) { prompt.prompt(); const r = await prompt.userChoice; if (r.outcome === "accepted") setHidden(true); }
    else setShowIos(true);
  };

  return (
    <div className="mb-6 rounded-xl border border-teal-500/40 bg-teal-500/[0.07] p-3" data-testid="install-banner">
      <div className="flex items-center gap-3">
        <img src="/icon-192.png" alt="" className="h-10 w-10 rounded-lg" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold">Als App speichern</p>
          <p className="text-xs text-slate-400">Mit Symbol auf dem Startbildschirm – öffnet sich wie eine echte App.</p>
        </div>
        <button onClick={install} className="h-9 px-3 rounded-lg bg-teal-500 text-slate-950 text-sm font-semibold flex items-center gap-1" data-testid="install-app-button"><Download className="h-4 w-4" />Holen</button>
        <button onClick={dismiss} className="text-slate-500" data-testid="install-dismiss-button"><X className="h-4 w-4" /></button>
      </div>
      {showIos && (
        <ol className="mt-3 text-sm text-slate-300 space-y-1.5 pl-1" data-testid="install-ios-steps">
          <li className="flex items-center gap-2">1. Unten auf <Share className="h-4 w-4 text-sky-400" /> <b>Teilen</b> tippen</li>
          <li className="flex items-center gap-2">2. <PlusSquare className="h-4 w-4" /> <b>Zum Home-Bildschirm</b> wählen</li>
          <li>3. Oben rechts auf <b>Hinzufügen</b> tippen</li>
        </ol>
      )}
    </div>
  );
}
